// Delivery interval from plan name/options (e.g. "1 month", "2 months").
export const planDeliveryMonths = plan => {
  const text = `${plan?.options?.[0]?.value ?? ""} ${plan?.name ?? ""}`.toLowerCase();
  const monthMatch = text.match(/(\d+)\s*months?\b/);
  if (monthMatch) return parseInt(monthMatch[1], 10);
  const everyMatch = text.match(/every\s+(\d+)\s*months?\b/);
  if (everyMatch) return parseInt(everyMatch[1], 10);
  return null;
};

export const sortPlansByDeliveryMonths = plans =>
  [...plans].sort((a, b) => {
    const ma = planDeliveryMonths(a) ?? Number.MAX_SAFE_INTEGER;
    const mb = planDeliveryMonths(b) ?? Number.MAX_SAFE_INTEGER;
    return ma - mb;
  });

export const findPlanForBottleCount = (plans, bottleCount) =>
  plans.find(p => planDeliveryMonths(p) === bottleCount) ?? plans[bottleCount - 1];

export const collectSubscribeAndSavePlans = product =>
  sortPlansByDeliveryMonths(
    product?.sellingPlanGroups
      ?.filter(g => ((g?.name ?? g?.title ?? "") + "").toLowerCase().includes("subscribe"))
      .flatMap(g => g.selling_plans) ?? [],
  );

/** Default subscribe plan for product cards / compact ATC — always the 1-month tier. */
export const getDefaultSubscriptionPlan = product => {
  const plans = collectSubscribeAndSavePlans(product);
  return plans.find(p => planDeliveryMonths(p) === 1) ?? plans[0] ?? null;
};

export const getDefaultSubscriptionPlanId = product =>
  getDefaultSubscriptionPlan(product)?.id ?? null;
